import axios, { AxiosError, AxiosResponse } from 'axios';
import { Auth } from '@trustpilot/ecommscript-integrationappauth';
import { logError } from './ecommscriptClient';
import { IntegrationConfig, BusinessUnitNames } from '../Model';
import { Tools } from '../Tools';

const configapi = `${process.env.REACT_APP_B2bApiUrl}/v1/private/ecommscript-configapi`;

export const integrationConfig = (businessUnitId: string, data: object): Promise<IntegrationConfig> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };

    return axios
        .put(`${configapi}/integrationconfig/${businessUnitId}`, data, { headers })
        .then((response) => {
            if (response.data) {
                return response.data;
            }
            return null;
        })
        .catch((err: AxiosError) => {
            logError(err);
            Tools.resetTokenIfUnauthorized(err.response);
            return null;
        });
};

export const getIntegrationConfig = (businessUnitId: string): Promise<IntegrationConfig | undefined> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };

    return axios
        .get(`${configapi}/integrationconfig/${businessUnitId}`, { headers })
        .then((response: AxiosResponse<IntegrationConfig>) => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            logError(err);
            Tools.resetTokenIfUnauthorized(err.response);
            return undefined;
        });
};

export const removeOldEcommerceSettings = (businessUnitId: string): Promise<undefined> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };

    return axios
        .delete(`${configapi}/ecommercesettings/${businessUnitId}`, { headers })
        .then(() => undefined)
        .catch((err: AxiosError) => {
            logError(err);
            Tools.resetTokenIfUnauthorized(err.response);
            return undefined;
        });
};

export const addDomain = (key: string, domain: string): Promise<BusinessUnitNames | undefined> => {
    const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${Auth.getAccessToken()}` };
    return axios
        .put(`${configapi}/referringdomain/${key}`, domain, { headers })
        .then((response: AxiosResponse<BusinessUnitNames>) => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            logError(err);
            Tools.resetTokenIfUnauthorized(err.response);
            return undefined;
        });
};



// WEBPACK FOOTER //
// ./src/Api/configapiClient.tsx